import { render, staticRenderFns } from "./ConfigurationForm173.vue?vue&type=template&id=28057d12&scoped=true&lang=pug&"
import script from "./ConfigurationForm173.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationForm173.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationForm173.vue?vue&type=style&index=0&id=28057d12&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28057d12",
  null
  
)

export default component.exports